export default __webpack_public_path__ + "static/media/5.198cd353.jpeg";